import { CommonAppConfigurationMapper, ICommonAppConfigurations, ICommonAppConfigurationsDTO } from "@/@common/models/CommonAppConfigurations";
import { gateBooleanToBoolean } from "../../../sg-core";


type TGateBoolean = "Y" | "N";

export interface IAppConfigurations extends ICommonAppConfigurations {
    auditointi?: {
        yhteenveto?: boolean;
    };

    kaannokset?: {
        fi?: { [key: string]: any };
        en?: { [key: string]: any }
    }
}



export interface IAppConfigurationsDTO extends ICommonAppConfigurationsDTO {
    auditointi: {
        yhteenveto: TGateBoolean;
    },

    kaannokset?: {
        fi?: { [key: string]: any };
        en?: { [key: string]: any }
    }
};


/**
 * Mapper primarly uses app spesific parameter and fallbacks to common parameters used in all safety applications.
 */
export const AppConfigurationMapper = {
    apiToDomain: (api: IAppConfigurationsDTO): IAppConfigurations => {
        return {
            ...CommonAppConfigurationMapper.apiToDomain(api),

            auditointi: {
                yhteenveto: api.auditointi?.yhteenveto ? gateBooleanToBoolean(api.auditointi.yhteenveto) : undefined

            },

            kaannokset: api.kaannokset,
        }
    },
};


